import { render } from "./SldHomeTopSearch.vue?vue&type=template&id=4bcd047f&scoped=true"
import script from "./SldHomeTopSearch.vue?vue&type=script&lang=js"
export * from "./SldHomeTopSearch.vue?vue&type=script&lang=js"

import "./SldHomeTopSearch.vue?vue&type=style&index=0&id=4bcd047f&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcd047f"]])

export default __exports__